import {forwardRef, useCallback, useEffect, useImperativeHandle, useRef} from "react";
import {SLowcodeList} from "shj-components";
import {config} from "./config.tsx";
import {apiData2Table} from "@/utils/data.ts";
import {getUserIdentityPage} from "@/services/user.ts";
import {getUser} from "shj-utils";
import {getRoleListFn} from "@/services/member.ts";

export const ChooseList = forwardRef((props, ref) => {
  const listRef = useRef()
  const {companyId} = getUser()
  const {editId, id, updateSelectedObj, rows} = props

  const fetchList = useCallback(({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      if(query.userNameKeyword){
        query.employeeFilter = {userNameKeyword: query.userNameKeyword}
        delete query.userNameKeyword
      }
      getUserIdentityPage({
        data: {
          companyId,
          queryEmployee: true,
          queryOrg: true,
          ...query
        }, params: {pageId: current, pageSize}
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }, [id, editId])

  const getStatusOptions = async () => {
    const roleList = await getRoleListFn({ data: {  } })
    return Promise.resolve({roleList})
  }

  useImperativeHandle(ref, () => {
    return {
      getRows: () => {
        const [_, selectedRows] = listRef.current?.getSelectedRows();
        return selectedRows
      }
    }
  }, [])

  const extension = {
    request: {fetchList, getStatusOptions},
    rowSelection: {
      preserveSelectedRowKeys: true,
      onChange: (_, selectedRows) => {
        updateSelectedObj(selectedRows)
      }
    },
    selectedRows: rows,
  }

  return <SLowcodeList
      ref={listRef}
      searchMode={'group'}
      {...extension}
      config={{...config}}/>
})